import { Form } from 'react-bootstrap';
import FormDate from './Date/FormDate';
import MobileNumberInput from './MobileNumber/MobileNumberInput';
import FormSelect from './Select/FormSelect';
import CountrySelect from "./CountrySelect/CountrySelect";

// import './Form.css';


// Form.defaultProps = {
//     className: "enterprise-form p-4"
// }

// Form.Group.defaultProps = {
//     className: "input-group"
// }

// Form.Label.defaultProps = {
//     className: "input-label"
// }

// Form.Control.defaultProps = {
//     className: "rounded-0 shadow-0 input-control bg-transparent"
// }

// Form.Text.defaultProps = {
//     className: ""
// }

// Form.Select.defaultProps = {
//     custom: true
// }

Form.Check.defaultProps = {
    custom: true

    // Form.Select = ({children,...rest}) => (
    //     <Form.Control
    //         as="select"
    //         {...rest}
    //         custom
    //     >
    //         {children}
    //     </Form.Control>
    // )

};Form.Select = FormSelect;
Form.MobileNumberInput = MobileNumberInput;
Form.Date = FormDate;
Form.CountrySelect = CountrySelect;

export default Form;